import React, { useContext, useState } from 'react';
import { Button, Table } from 'reactstrap';
import { SpinnerButton } from 'common/SpinnerButton';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { ListItem } from './ListItem';
import { AddDomainModal } from '../Modals/AddDomainModal';
import { AuthContext } from 'contexts/AuthContext';
import { addDomain, switchDomainStatus } from "utils/api";

export const List = ({ domains, isLoading, refreshDomains }) => {
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { handleError } = useContext(AuthContext);

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const handleSwitchStatus = async (item) => {
        try {
            await switchDomainStatus(item.id, { is_active: !item.is_active });
            addFlashMessage('success', 'Domain status successfully switched');
            refreshDomains();
        } catch (err) {
            handleError(err);
        }
    };

    const toggleCreateModal = () => {
        setIsCreateModalOpen(!isCreateModalOpen);
    };

    const handleAddDomain = async (params) => {
        try {
            await addDomain(params);
            addFlashMessage('success', 'Domain successfully added');
            refreshDomains();
            toggleCreateModal();
        } catch (err) {
            handleError(err);
        }
    };

    return (
        <div className="list publication-list">
            {isLoading ?
                <SpinnerButton/>
                :
                <div>
                    {window.innerWidth > 1250 &&
                        <div className="list__utility-row list__utility-row--desktop">
                            <div className="d-flex">
                                <Button
                                    onClick={toggleCreateModal}
                                    color="primary"
                                >Add Domain</Button>
                            </div>
                        </div>
                    }
                    {1250 >= window.innerWidth && window.innerWidth > 624 &&
                        <div className="list__utility-row list__utility-row--tablet">
                            <div className="d-flex mt-2 w-100 justify-content-end">
                                <div className="mr-2 d-flex">
                                    <Button
                                        onClick={toggleCreateModal}
                                        color="primary"
                                        className="mb-0"
                                    >
                                        <i className="fa fa-plus"/>&nbsp;
                                        Add Domain
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                    {624 >= window.innerWidth &&
                        <div className="list-utility-row list__utility-row--mobile">
                            <div className="d-flex mb-2">
                                <Button
                                    onClick={toggleCreateModal}
                                    color="primary"
                                    className="ml-1"
                                    style={{ flex: '0 0 50%' }}
                                >
                                    <i className="fa fa-plus"/>&nbsp;
                                    Add Domain
                                </Button>
                            </div>
                        </div>
                    }

                    {domains.length < 1 ?
                        <div>
                            No results found
                        </div>
                        :
                        <div>
                            <Table className="responsive-table">
                                <tbody>
                                <tr className="responsive-table header-row">
                                    <th>Domain ID</th>
                                    <th>Domain Name</th>
                                    <th style={{ width: '150px' }}>Actions</th>
                                </tr>

                                {domains.map((domain) => (
                                    <ListItem
                                        key={domain.id}
                                        domain={domain}
                                        handleSwitchStatus={handleSwitchStatus}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    }
                </div>
            }
            <AddDomainModal
                isOpen={isCreateModalOpen}
                toggle={toggleCreateModal}
                handleError={handleError}
                handleAddDomain={handleAddDomain}
            />
        </div>
    );
};
